// This accounts for both single-line and multi-line eslint disables
const eslintDisableRegexString = new RegExp('^[ \t]*/[/*] eslint-(enable|disable)', 'g');

/**
 *  We don't want eslint disables in our public facing examples.
 */
export const removeEslintDisables = (sourceCode: string): string => {
	const transformedCode = sourceCode
		.split('\n')
		.filter((line) => !line.match(eslintDisableRegexString))
		.join('\n');

	return transformedCode;
};
